import { render } from "./Main.vue?vue&type=template&id=10e24d6a&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=10e24d6a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10e24d6a"

export default script